module.exports = __webpack_public_path__ + "09a74fe5d2973301856ea1f35aab9f27.svg";